import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';

import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";
import queryString from 'querystring';
import {fetchConfirmEmail} from "../../creators/user.confirmEmail";
import {LoadingBar} from "../components/Loader";
import _ from "lodash";
import {fetchCurrentUser} from "../../creators/currentUser";



class ConfirmEmail extends React.Component {
    constructor(props) {
        super(props);
        let search = this.props.location.search.replace("?","");
        this.actionToken = queryString.parse(search).actionToken;

        if(this.actionToken){
            this.props.fetchConfirmEmail({actionToken : this.actionToken});
        }
        else{
            this.props.history.push("/");
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.userConfirmEmailInitialized){
            _.delay(() =>{
                this.props.fetchCurrentUser();
                this.props.history.push(createLink("userMeSettingsEmailAndPassword"));
            }, 2000);
        }
    }




    render() {
        return (
            <div id="confirm-email">
                <Helmet>
                    <title>{config.preTitle}Email Confirmé{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card">
                        <div className="main-wrapper">
                            <Title heading={"heading-2"} display={"display-2"}>Confirmation de votre email</Title>
                            {this.actionToken && this.props.userConfirmEmailInitialized && !this.props.userConfirmEmailError.error ? (
                                <div className="text">
                                    <p className={"color-success"}>Votre email est bien confirmé merci</p>
                                </div>
                            ) : (!this.props.userConfirmEmailLoading ? (
                                    <div className="text">
                                        <p className={"color-danger"}>{this.props.userConfirmEmailError.message ? this.props.userConfirmEmailError.message : "Votre code de validation est incorrecte "}</p>
                                    </div>
                                ) : (<div className="text pb-8">
                                    <LoadingBar />
                                </div>)

                            )}

                            <div className="text">
                                <p>Si vous avez le moindre problème n’hésitez pas à nous <Link to={createLink("contact")}>contacter</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    userConfirmEmail: state.userConfirmEmail.data,
    userConfirmEmailError: state.userConfirmEmail.error,
    userConfirmEmailInitialized: state.userConfirmEmail.initialized,
    userConfirmEmailLoading: state.userConfirmEmail.loading
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchConfirmEmail,
    fetchCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);

